"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerAdventureEventHandlerActivator = exports.TriggerAdventureEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class TriggerAdventureEventHandlerArgs {
    constructor() {
        this.__type = EventHandlerType_1.EventHandlerType.TriggerAdventure;
        this.__typeName = "TriggerAdventure";
    }
}
exports.TriggerAdventureEventHandlerArgs = TriggerAdventureEventHandlerArgs;
let TriggerAdventureEventHandlerActivator = class TriggerAdventureEventHandlerActivator {
    activate(sequence, container, handler, e) {
        const adventure = container.adventure;
        Registries_1.AdventureHandlers.getItem(adventure.__typeName).handleEvent(sequence, container, adventure, e);
    }
};
TriggerAdventureEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.TriggerAdventure)
], TriggerAdventureEventHandlerActivator);
exports.TriggerAdventureEventHandlerActivator = TriggerAdventureEventHandlerActivator;
